import { render, staticRenderFns } from "./SimpleTrunkAnalysis4.vue?vue&type=template&id=4dd2194e&scoped=true"
import script from "./SimpleTrunkAnalysis4.vue?vue&type=script&lang=ts"
export * from "./SimpleTrunkAnalysis4.vue?vue&type=script&lang=ts"
import style0 from "./SimpleTrunkAnalysis4.vue?vue&type=style&index=0&id=4dd2194e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd2194e",
  null
  
)

export default component.exports